/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './ValidationMessage.scss'
import { Toast, ToastHeader, ToastBody } from 'reactstrap'
export enum MessageTypes {
	Success = 'success',
	Error = 'danger',
}
export interface IValidationMessageProps {
	showValidationMessage: boolean
	validationMessage: string
	toggleAction: any
	MessageType: MessageTypes
}

export class ValidationMessage extends React.Component<IValidationMessageProps> {
	render(): React.ReactNode {
		return (
			<Toast isOpen={this.props.showValidationMessage} className="toastClass">
				<ToastHeader icon={this.props.MessageType} toggle={this.props.toggleAction}>
					{this.props.MessageType === 'danger' ? 'Error' : 'Success'}
				</ToastHeader>
				<ToastBody>{this.props.validationMessage}</ToastBody>
			</Toast>
		)
	}
}
